import {useMutation} from '@tanstack/react-query';
import {AxiosHttpClient} from '../../envisia/auth/axios-http-client';
import {environment} from '../../../environments/environment';

interface Props {
  id: number;
}

export function useMultilayerPlanPdfMutation({id}: Props) {
  const {mutate} = useMutation({
    mutationFn: () =>
      AxiosHttpClient.post<{ object: string }>(`${environment.apiv4uri}multilayerplan/pdf/${id}`, {}),
    onSuccess: (response) => {
      window.open(response.object, '_blank');
    },
  });

  return {
    openPdf: mutate,
  };
}
